import type { IRatingMatrixFrameworkRange } from '__generated__';
import { baseApi, rangeListTag } from 'store/api';
import {
  API,
  APIRead,
  getAllDynamic,
  normalizeError,
} from 'utils/api-client';
import { buildRangeFilter } from './helpers';

export const ratingMatrixFrameworkRangeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRanges: builder.query<IRatingMatrixFrameworkRange[], { subParameterID: number }>({
      async queryFn({ subParameterID }) {
        try {
          const { value } = await getAllDynamic<IRatingMatrixFrameworkRange>(
            (body) => APIRead.api.ratingMatrixFrameworkRangeGetAllDynamicCreate(body),
            {
              filter: buildRangeFilter(subParameterID),
            },
          );

          return { data: value };
        } catch (error) {
          return { error: normalizeError(error) };
        }
      },
      providesTags: (_result, _error, arg) => [rangeListTag(arg.subParameterID)],
    }),

    saveRangesBulk: builder.mutation<
      string,
      { subParameterID: number; items: Partial<IRatingMatrixFrameworkRange>[] }
    >({
      async queryFn({ items }) {
        try {
          const { data } = await API.api.ratingMatrixFrameworkRangeSaveBulkCreate(
            items as IRatingMatrixFrameworkRange[],
          );
          return { data };
        } catch (error) {
          return { error: normalizeError(error) };
        }
      },
      invalidatesTags: (_result, _error, arg) => [rangeListTag(arg.subParameterID)],
    }),
  }),
});

export const { useGetRangesQuery, useSaveRangesBulkMutation } = ratingMatrixFrameworkRangeApi;
